<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'

const router = useRouter()
const route = useRoute()

const bowlerSearch = ref<string>(String())
const clubSearch = ref<string>(String())

const emit = defineEmits(['submit'])

defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
})

function onRouteChange(): void {
  bowlerSearch.value = (route.query.bowler ?? String()) as string
  clubSearch.value = (route.query.club ?? String()) as string

  if (bowlerSearch.value.length > 0 || clubSearch.value.length > 0) {
    submit()
  }
}

function setQuery(): void {
  router.replace({
    path: '/averages',
    query: {
      bowler: bowlerSearch.value,
      club: clubSearch.value,
    },
  })
}

function submit(): void {
  emit('submit', {
    bowler: bowlerSearch.value,
    club: clubSearch.value,
  })
}

onMounted(onRouteChange)

watch(() => route.query, onRouteChange)
</script>

<template>
  <form class="average-search-form" @submit.prevent="setQuery">
    <FormTextInput
      v-model="bowlerSearch"
      type="text"
      :label="$t('field-labels.bowler-search')"
      :is-disabled="isLoading"
      autocomplete="off"
    />

    <FormTextInput
      v-model="clubSearch"
      type="text"
      :label="$t('field-labels.club-search')"
      :is-disabled="isLoading"
      autocomplete="off"
    />

    <FormButton :is-busy="isLoading">
      {{ $t('averages.search') }}
    </FormButton>

    <FormButton class="inline" :is-busy="isLoading">
      <FontAwesomeIcon icon="magnifying-glass" />
    </FormButton>
  </form>
</template>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.average-search-form {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;
  font-size: 0.75em;

  @media screen and (min-width: $break-point-tablet) {
    flex-flow: row nowrap;
    align-items: flex-end;
  }

  .form-text-input {
    flex: 1;
  }

  .form-button.inline {
    display: none;
    min-width: min-content;
    width: min-content;
    height: min-content;

    @media screen and (min-width: $break-point-tablet) {
      display: block;
    }
  }

  .form-button:not(.inline) {
    margin-top: 1em;

    @media screen and (min-width: $break-point-tablet) {
      display: none;
    }
  }
}
</style>
